import product1 from "./img/quiz.png"
import product2 from "./img/hourglass.png"
import product3 from "./img/calculator.png"
import product4 from "./img/shop.png"
import product5 from "./img/todo.png"
import product6 from "./img/weather.png"
import product7 from "./img/netflix.png"
import product8 from "./img/login.png"
import product9 from "./img/portfolio.png"

export const PRODUCTS = [
    {
      id: 1,
      link: "https://storied-kulfi-3ed9a8.netlify.app",
      img: product1,
      title: "Javascript Quiz",
    },
    {
      id: 2,
      link: "https://princerequiem7.github.io/hourglass/",
      img: product2,
      title: "Animated Hourglass",
    },
    {
      id: 3,
      link: "https://princerequiem7.github.io/jscalculator/",
      img: product3,
      title: "Basic Calculator",
    },
    {
      id: 4,
      link: " https://superlative-gecko-f9e26b.netlify.app/",
      img: product4,
      title: "Basic React E-Commerce Shop",
    },
    {
      id: 5,
      link: "https://cheerful-ganache-a0ff65.netlify.app",
      img: product5,
      title: "Basic React Todo List App",
    }, 
    {
      id: 6,
      link: "https://gleaming-lollipop-55ae16.netlify.app",
      img: product6,
      title: "Basic React Weather Report App",
    },
     {
      id: 7,
      link: "https://superb-naiad-5c5a6f.netlify.app",
      img: product7,
      title: "Netflix Home Page Replica",
    }, 
    {
      id: 8,
      link: "https://chic-stroopwafel-033d0e.netlify.app",
      img: product8,
      title: "Basic React Login/Register Page",
    },
    {
      id: 9,
      link: "https://starlit-custard-9d9887.netlify.app/",
      img: product9,
      title: "Standard HTML/CSS Portfolio Website",
    }

  ]